var _module_exports = "<span>This is a secured private workroom. Only you and {{flashScope.task.contractor.fullName}} can see the files, comments and passwords.</span>";;
var path = 'views/flashes/private_workroom.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;